<template>
  <div class="height-100">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "NoticeIndex"
}
</script>

<style scoped>

</style>
